import {
  IContractHierarchyRuleCreateRequest,
  IContractHierarchyRuleUpdateRequest,
} from "types/ContractHierarchyRule/ContractHierarchyRule";
import {
  IAllContractHierarchyRulesResponse,
  IContractHierarchyRuleResponse,
} from "types/ContractHierarchyRule/ContractHierarchyRuleResponse";

import { api } from ".";

const contractHierarchyRulesQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractHierarchyRulesByContract: builder.query<
      IAllContractHierarchyRulesResponse,
      { providerId: string; payerId: number }
    >({
      query: ({ providerId, payerId }) =>
        `contract-hierarchy-rules/by-contract/${providerId}/${payerId}`,
      providesTags: ["ContractHierarchyRules"],
    }),
    createContractHierarchyRule: builder.mutation<
      IContractHierarchyRuleResponse,
      IContractHierarchyRuleCreateRequest
    >({
      query: (body) => ({
        url: "contract-hierarchy-rules",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ContractHierarchyRules"],
    }),
    updateContractHierarchyRule: builder.mutation<
      IContractHierarchyRuleResponse,
      IContractHierarchyRuleUpdateRequest
    >({
      query: ({ id, ...body }) => ({
        url: `contract-hierarchy-rules/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ContractHierarchyRules"],
    }),
    deleteContractHierarchyRule: builder.mutation<any, string>({
      query: (id) => ({
        url: `contract-hierarchy-rules/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContractHierarchyRules"],
    }),
  }),
});

export const {
  useGetContractHierarchyRulesByContractQuery,
  useCreateContractHierarchyRuleMutation,
  useUpdateContractHierarchyRuleMutation,
  useDeleteContractHierarchyRuleMutation,
} = contractHierarchyRulesQueries;
